import Vue from 'vue'

class EmailService {
  async modelos() {
    try {
      const response = await Vue.prototype.$http.get(
        `util/email_modelos`
      )
      return await response.data;
    } catch (error) {
      throw error
    }
  }
}

export default new EmailService();
